import { useTranslation } from 'react-i18next';
import { GridColumn } from 'src/components/GridWrapper';
import { CenterHeaderCell } from 'src/components/custom-headers/CenterHeaderCell';
import ViewPeriods from '../../../sections/view_periods/view_periods_cell/ViewPeriods';

const useFiscalYearsTableColumns = () => {
  const { t } = useTranslation();
  const columns: GridColumn<any>[] = [
    {
      field: 'fiscalYearContent',
      title: t('Fiscal Year'),
      menu: false,
      sortable: false,
      dataType: 'fixed',
      headerCell: CenterHeaderCell,
    },
    {
      field: 'yearStartDate',
      title: t('Start Date'),
      menu: false,
      sortable: false,
      dataType: 'fixed',
      headerCell: CenterHeaderCell,
    },
    {
      field: 'yearEndDate',
      title: t('End Date'),
      menu: false,
      sortable: false,
      dataType: 'fixed',
      headerCell: CenterHeaderCell,
    },
    {
      field: 'noOFPeriods',
      title: t('No. of periods'),
      menu: false,
      sortable: false,
      dataType: 'fixed',
      headerCell: CenterHeaderCell,
    },
    {
      field: '',
      title: 'Actions',
      menu: false,
      sortable: false,
      component: ViewPeriods,
      headerCell: CenterHeaderCell,
    },
  ];
  return columns;
};

export default useFiscalYearsTableColumns;
